import Column from "@components/column";
import styled from "@emotion/styled";

export const Container = styled(Column)`
  gap: 24px;
  padding: 0;
  background: #f8fafc;
  min-height: 100vh;
  max-width: 98%;
`;

export const StoreHeaderSection = styled.section`
  position: relative;
  margin-bottom: 0;
`;

export const CoverImageContainer = styled.div`
  position: relative;
  height: 320px;
  width: 100%;
  overflow: hidden;
`;

export const CoverImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const HeaderOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(255, 140, 0, 0.2) 0%,
    rgba(255, 169, 77, 0.4) 100%
  );
  pointer-events: none;
`;

export const StoreHeaderContent = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 32px;
  display: flex;
  align-items: flex-end;
  gap: 24px;
  z-index: 10;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
`;

export const NotificationBanner = styled.div`
  position: absolute;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(12px);
  padding: 10px 24px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  z-index: 20;
  border: 1px solid rgba(255, 255, 255, 0.5);
  animation: slideDown 0.5s ease-out;
  max-width: 90%;

  @keyframes slideDown {
    from {
      transform: translate(-50%, -100%);
      opacity: 0;
    }
    to {
      transform: translate(-50%, 0);
      opacity: 1;
    }
  }
`;

export const NotificationIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #ff8c00;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  flex-shrink: 0;
`;

export const NotificationText = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 400px;

  @media (max-width: 768px) {
    max-width: 200px;
  }
`;

export const CoverActionIcon = styled.button`
  position: absolute;
  top: 24px;
  right: 24px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
  z-index: 20;
  transition: all 0.3s ease;

  &:hover {
    background: white;
    color: #ff8c00;
    transform: scale(1.1);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
  }
`;

export const AvatarContainer = styled.div`
  position: relative;
  border: 4px solid white;
  border-radius: 50%;
  background: white;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
`;

export const AvatarImage = styled.img`
  width: 140px;
  height: 140px;
  border-radius: 50%;
  object-fit: cover;
  background: #f1f5f9;
`;

export const OnlineIndicator = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #10b981;
  border: 3px solid white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
`;

export const StoreInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StoreNameRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

export const BadgeContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const FeaturedBadge = styled.span`
  padding: 8px 16px;
  background: #ffd700;
  color: #854d0e;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const PopularBadge = styled.span`
  padding: 8px 16px;
  background: #ef4444;
  color: white;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const VerificationBadge = styled.span`
  padding: 8px 16px;
  background: #10b981;
  color: white;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const StoreMeta = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  flex-wrap: wrap;
`;

export const MetaItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;

export const ActionButton = styled.button<{ primary?: boolean }>`
  padding: 12px 20px;
  background: ${(props) =>
    props.primary ? "white" : "rgba(255, 255, 255, 0.2)"};
  color: ${(props) => (props.primary ? "#ff8c00" : "white")};
  border: 2px solid white;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);

  &:hover {
    background: ${(props) =>
      props.primary ? "#f8fafc" : "rgba(255, 255, 255, 0.3)"};
    transform: translateY(-2px);
  }
`;

export const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  gap: 24px;
  padding: 0px;
  max-width: 99%;
  margin: 0 auto;
  width: 100%;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

export const LeftColumn = styled(Column)`
  gap: 24px;
`;

export const RightColumn = styled(Column)`
  gap: 24px;
`;

export const Section = styled(Column)`
  gap: 20px;
  padding: 24px;
  background: white;
  border-radius: 20px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 8px 30px rgba(255, 140, 0, 0.15);
    border-color: #ffd8a8;
  }
`;

export const SectionHeader = styled.div`
  padding-bottom: 16px;
  border-bottom: 2px solid #f8fafc;
  display: flex;
  align-items: center;
`;

export const MetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const MetricCard = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 24px;
  background: white;
  border-radius: 20px;
  border: 1px solid #f1f5f9;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow:
    0 4px 6px -1px rgba(0, 0, 0, 0.02),
    0 2px 4px -1px rgba(0, 0, 0, 0.02);

  &:hover {
    transform: translateY(-4px);
    box-shadow:
      0 20px 25px -5px rgba(0, 0, 0, 0.05),
      0 10px 10px -5px rgba(0, 0, 0, 0.01);
    border-color: #ffd8a8;
  }
`;

export const MetricIcon = styled.div<{ bgColor?: string }>`
  width: 64px;
  height: 64px;
  border-radius: 18px;
  background: ${(props) =>
    props.bgColor
      ? `linear-gradient(135deg, ${props.bgColor}15 0%, ${props.bgColor}30 100%)`
      : "linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%)"};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.bgColor || "#ff8c00"};
  font-weight: bold;
  box-shadow: inset 0 2px 4px rgba(255, 255, 255, 0.6);
`;

export const MetricContent = styled.div`
  flex: 1;
`;

export const MetricValue = styled.div`
  font-size: 28px;
  font-weight: 800;
  color: #1e293b;
  margin-bottom: 4px;
  letter-spacing: -0.5px;
  background: linear-gradient(to right, #1e293b, #475569);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const MetricLabel = styled.div`
  font-size: 14px;
  color: #64748b;
  font-weight: 600;
  margin-bottom: 4px;
`;

export const MetricGrowth = styled.div<{ positive: boolean }>`
  font-size: 12px;
  font-weight: 700;
  color: ${(props) => (props.positive ? "#10b981" : "#ef4444")};
`;

export const MetricSubtext = styled.div<{ alert?: boolean }>`
  font-size: 12px;
  color: ${(props) => (props.alert ? "#ef4444" : "#64748b")};
  font-weight: 500;
`;

export const ChartContainer = styled.div`
  width: 100%;
`;

export const ChartActions = styled.div`
  display: flex;
  gap: 8px;
`;

export const ChartActionButton = styled.button`
  padding: 8px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #fff7ed;
    color: #ff8c00;
    border-color: #ffd8a8;
  }
`;

export const ProductsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ProductItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #f1f5f9;
  transition: all 0.2s ease;

  &:hover {
    background: #fff7ed;
    border-color: #ffd8a8;
  }
`;

export const ProductRank = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #ff8c00;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
`;

export const ProductInfo = styled.div`
  flex: 1;
`;

export const ProductName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 4px;
`;

export const ProductStats = styled.div`
  display: flex;
  gap: 12px;
`;

export const ProductStat = styled.div`
  font-size: 12px;
  color: #64748b;
`;

export const ProductTrend = styled.div<{ positive: boolean }>`
  color: ${(props) => (props.positive ? "#10b981" : "#ef4444")};
`;

export const InfoGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const InfoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f8fafc;
  border-radius: 12px;
`;

export const InfoIcon = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #fff7ed;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ff8c00;
`;

export const InfoContent = styled.div`
  flex: 1;
`;

export const InfoLabel = styled.div`
  font-size: 12px;
  color: #64748b;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
`;

export const InfoValue = styled.div`
  font-size: 14px;
  color: #1e293b;
  font-weight: 600;
`;

export const AvailabilityList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const AvailabilityItem = styled.div`
  display: grid;
  grid-template-columns: 100px 20px 1fr;
  align-items: center;
  padding: 12px 16px;
  background: #f8fafc;
  border-radius: 10px;
  border: 1px solid #f1f5f9;
  transition: all 0.2s ease;

  &:hover {
    background: #fff7ed;
    border-color: #ffd8a8;
  }
`;

export const Day = styled.div`
  font-weight: 600;
  color: #374151;
  font-size: 14px;
`;

export const StatusDot = styled.div<{ color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
`;

export const Status = styled.div<{ color: string }>`
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => props.color};
`;

export const OrderLegend = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LegendColor = styled.div<{ color: string }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
`;

export const LegendText = styled.div`
  font-size: 14px;
  color: #64748b;
`;

export const CategoriesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const CategoryItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CategoryInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CategoryName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
`;

export const CategoryStats = styled.div`
  font-size: 12px;
  color: #64748b;
`;

export const CategoryBar = styled.div`
  width: 100%;
  height: 6px;
  background: #f1f5f9;
  border-radius: 3px;
  overflow: hidden;
`;

export const CategoryFill = styled.div<{ width: string }>`
  width: ${(props) => props.width};
  height: 100%;
  background: #ff8c00;
  border-radius: 3px;
  transition: width 0.3s ease;
`;

export const ActivitiesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ActivityItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #f1f5f9;
  transition: all 0.2s ease;

  &:hover {
    background: #fff7ed;
    border-color: #ffd8a8;
  }
`;

export const ActivityIcon = styled.div<{ type: string }>`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #fff7ed;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ff8c00;
`;

export const ActivityContent = styled.div`
  flex: 1;
`;

export const ActivityText = styled.div`
  font-size: 14px;
  color: #1e293b;
  font-weight: 500;
  margin-bottom: 2px;
`;

export const ActivityTime = styled.div`
  font-size: 12px;
  color: #64748b;
`;

// Enhanced Documents Section Styles
export const DocumentsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const DocumentItem = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: #f8fafc;
  border-radius: 16px;
  border: 1px solid #f1f5f9;
  transition: all 0.3s ease;

  &:hover {
    background: #fff7ed;
    border-color: #ffd8a8;
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(255, 140, 0, 0.1);
  }
`;

export const DocumentIcon = styled.div`
  width: 54px;
  height: 54px;
  border-radius: 14px;
  background: #fff7ed;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ff8c00;
  flex-shrink: 0;
`;

export const DocumentInfo = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`;

export const DocumentContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const DocumentLabel = styled.div`
  font-size: 16px;
  color: #1e293b;
  font-weight: 600;
`;

export const DocumentStatus = styled.div<{
  verified?: boolean;
  pending?: boolean;
}>`
  font-size: 12px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 6px;
  background: ${(props) =>
    props.verified ? "#10b981" : props.pending ? "#f59e0b" : "#6b7280"};
  color: white;
  width: fit-content;
`;

export const DocumentActions = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const DocumentAction = styled.button<{ disabled?: boolean }>`
  padding: 8px 16px;
  background: ${(props) => (props.disabled ? "#94a3b8" : "#ff8c00")};
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  transition: all 0.2s ease;
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};

  &:hover {
    background: ${(props) => (props.disabled ? "#94a3b8" : "#e67e00")};
    transform: ${(props) => (props.disabled ? "none" : "translateY(-1px)")};
  }
`;

export const DocumentDownload = styled.button<{ disabled?: boolean }>`
  padding: 8px;
  background: ${(props) => (props.disabled ? "#f1f5f9" : "#f8fafc")};
  color: ${(props) => (props.disabled ? "#94a3b8" : "#64748b")};
  border: 1px solid ${(props) => (props.disabled ? "#e2e8f0" : "#e2e8f0")};
  border-radius: 8px;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  transition: all 0.2s ease;
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};

  &:hover {
    background: ${(props) => (props.disabled ? "#f1f5f9" : "#fff7ed")};
    color: ${(props) => (props.disabled ? "#94a3b8" : "#ff8c00")};
    border-color: ${(props) => (props.disabled ? "#e2e8f0" : "#ffd8a8")};
  }
`;

// Document Modal Styles
export const DocumentModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: white;
  border-radius: 12px;
  overflow: hidden;
`;

export const DocumentModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
`;

export const DocumentControls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ControlButton = styled.button<{ disabled?: boolean }>`
  padding: 8px 12px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  color: ${(props) => (props.disabled ? "#94a3b8" : "#64748b")};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  transition: all 0.2s ease;
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};

  &:hover {
    background: ${(props) => (props.disabled ? "white" : "#fff7ed")};
    border-color: ${(props) => (props.disabled ? "#e2e8f0" : "#ffd8a8")};
    color: ${(props) => (props.disabled ? "#94a3b8" : "#ff8c00")};
  }
`;

export const ZoomLevel = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
  margin-left: 8px;
  min-width: 40px;
  text-align: center;
`;

export const DocumentImageContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: #f8fafc;
  overflow: auto;
`;

export const DocumentImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  transition: transform 0.3s ease;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
`;

export const EmptyState = styled.div`
  text-align: center;
  color: #94a3b8;
  font-style: italic;
  padding: 40px 20px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px dashed #cbd5e1;
`;

// Add these to your existing style.ts file

export const LocationModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: white;
  border-radius: 12px;
  overflow: hidden;
`;

export const LocationModalHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const LocationInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-end;
`;

export const LocationDetail = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #64748b;
`;

export const MapContainer = styled.div`
  flex: 1;
  min-height: 400px;
`;

export const LocationActions = styled.div`
  padding: 16px 20px;
  border-top: 1px solid #e2e8f0;
  display: flex;
  gap: 12px;
`;

export const LocationActionButton = styled.a`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: #ff8c00;
  color: white;
  border: none;
  border-radius: 6px;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: #e67e00;
  }
`;

export const LocationCard = styled.div`
  background: white;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
`;

export const LocationPreview = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MapPreview = styled.div`
  height: 200px;
  position: relative;
`;

export const NoLocation = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 8px;
  background: #f8fafc;
`;

export const LocationDetails = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const LocationDetailItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const LocationLabel = styled.div`
  font-size: 12px;
  color: #64748b;
  margin-bottom: 2px;
`;

export const LocationValue = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #1e293b;
`;

export const OverviewCardsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  width: 100%;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

// Contact Modal Styles
export const ContactModalContainer = styled.div`
  padding: 0;
`;

export const ContactModalHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 24px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
`;

export const ContactStoreInfo = styled.div`
  flex: 1;
`;

export const StoreAvatar = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 12px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ContactMethods = styled.div`
  padding: 24px;
`;

export const ContactMethod = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  margin-bottom: 12px;
  transition: all 0.2s ease;

  &:hover {
    border-color: #3b82f6;
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.1);
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ContactMethodIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #475569;
`;

export const ContactMethodContent = styled.div`
  flex: 1;
`;

export const ContactMethodLabel = styled.div`
  font-size: 12px;
  color: #64748b;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
`;

export const ContactMethodValue = styled.div`
  font-size: 16px;
  color: #1e293b;
  font-weight: 600;
`;

export const ContactMethodActions = styled.div`
  display: flex;
  gap: 8px;
`;

export const ContactActionButton = styled.a`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #3b82f6;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: all 0.2s ease;

  &:hover {
    background: #2563eb;
    transform: translateY(-1px);
  }
`;

export const CopyButton = styled.button<{ copied: boolean }>`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: ${(props) => (props.copied ? "#10b981" : "#64748b")};
  color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${(props) => (props.copied ? "#059669" : "#475569")};
    transform: translateY(-1px);
  }
`;

export const StoreHours = styled.div`
  padding: 0 24px 24px;
`;

export const HoursList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const HourItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
`;

export const DayLabel = styled.span`
  font-size: 14px;
  color: #475569;
  font-weight: 500;
`;

export const TimeSlot = styled.span<{ color: string }>`
  font-size: 14px;
  color: ${(props) => props.color};
  font-weight: 600;
`;

export const ContactFooter = styled.div`
  padding: 16px 24px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
`;

export const AvatarPlaceholder = styled.div<{ size?: number; bg?: string }>`
  width: ${(props) => props.size || 140}px;
  height: ${(props) => props.size || 140}px;
  border-radius: 50%;
  background-color: ${(props) => props.bg || "#10b981"};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${(props) => (props.size ? props.size * 0.4 : 56)}px;
  font-weight: 700;
  border: 4px solid white;
  box-shadow:
    0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
`;

export const SliderArrow = styled.div<{ right?: boolean }>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${(props) => (props.right ? "right: 20px" : "left: 20px")};
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 20;
  transition: all 0.2s ease;
  color: white;

  &:hover {
    background: rgba(255, 255, 255, 0.5);
    transform: translateY(-50%) scale(1.1);
  }

  svg {
    stroke-width: 3px;
  }
`;

export const DashboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 0;
  background: transparent;
  width: 100%;
`;

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  border-radius: 14px;
  border: 1px solid #f1f5f9;
  background: #ffffff;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
`;

export const TableHeader = styled.thead`
  background: #f8fafc;
`;

export const TableRow = styled.tr`
  transition: all 0.2s ease;

  &:hover {
    background: #f1f5f940;
  }

  &:not(:last-child) {
    td {
      border-bottom: 1px solid #f1f5f9;
    }
  }
`;

export const TableHead = styled.th`
  padding: 16px;
  text-align: left;
  font-size: 11px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid #f1f5f9;
`;

export const TableBody = styled.tbody``;

export const TableCell = styled.td`
  padding: 16px;
  font-size: 13px;
  color: #475569;
  font-weight: 600;
`;

export const StatusBadge = styled.div<{ color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  background: ${(props) => `${props.color}15`};
  color: ${(props) => props.color};
  border-radius: 100px;
  font-size: 11px;
  font-weight: 700;
  border: 1px solid ${(props) => `${props.color}30`};
`;

export const BreakdownGrid = styled.div`
  grid-template-columns: repeat(4, 1fr);
  display: grid;
  gap: 20px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const BreakdownCard = styled.div<{ highlight?: boolean }>`
  padding: 24px;
  background: ${(props) =>
    props.highlight
      ? "linear-gradient(135deg, #1e293b 0%, #334155 100%)"
      : "#ffffff"};
  color: ${(props) => (props.highlight ? "#ffffff" : "inherit")};
  border-radius: 20px;
  border: 1px solid ${(props) => (props.highlight ? "transparent" : "#f1f5f9")};
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.04);
  }
`;

export const IconContainer = styled.div<{ color: string; highlight?: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: ${(props) =>
    props.highlight ? "rgba(255,255,255,0.1)" : `${props.color}15`};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => (props.highlight ? "#ffffff" : props.color)};
`;

export const AmountText = styled.span<{ positive: boolean }>`
  font-weight: 700;
  color: ${(props) => (props.positive ? "#10b981" : "#f43f5e")};
`;

export const BreakdownLabel = styled.div<{ inverted?: boolean }>`
  font-size: 11px;
  font-weight: 800;
  color: ${(props) => (props.inverted ? "rgba(255,255,255,0.7)" : "#94a3b8")};
  text-transform: uppercase;
  letter-spacing: 0.1em;
`;

export const SectionTitle = styled.h3`
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 24px 0;
  display: flex;
  align-items: center;
  gap: 12px;
  letter-spacing: -0.01em;
  text-transform: uppercase;
  font-family: inherit;

  svg {
    color: #64748b;
    width: 18px;
    height: 18px;
    stroke-width: 2.5;
  }
`;

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const StatItem = styled.div`
  padding: 20px;
  background: #f8fafc;
  border-radius: 14px;
  border: 1px solid #f1f5f9;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  gap: 10px;

  &:hover {
    background: #ffffff;
    border-color: #e2e8f0;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
  }
`;

export const StatLabel = styled.div`
  font-size: 11px;
  color: #94a3b8;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const StatValue = styled.div<{ color?: string }>`
  font-size: 24px;
  font-weight: 800;
  color: ${(props) => props.color || "#1e293b"};
  letter-spacing: -0.01em;
`;

export const BreakdownValue = styled.div<{
  color?: string;
  inverted?: boolean;
}>`
  font-size: 24px;
  font-weight: 800;
  color: ${(props) => (props.inverted ? "#ffffff" : props.color || "#0f172a")};
  letter-spacing: -0.02em;
`;

